import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, Inject, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as moment from 'moment';
import screenfull from 'screenfull';

import { DataService, DataDirection } from '../shared/data.service';
import { TeamMatchData, HomeTeamMatchData, AwayTeamMatchData, MatchSide } from '../shared/team-match-data.model';
import { TeamStatistic } from '../shared/team-statistic.model';
import { Lineup } from '../shared/lineup.model';
import { Player } from '../shared/player.model';
import { MissingPlayer } from '../shared/missing-player.model';
import { Injury } from '../shared/injury.model';
import { Transfer } from '../shared/transfer.model';
import { PenaltyStatistic } from '../shared/penalty-statistic.model';
import { Penalty } from '../shared/penalty.model';
import { Match, MatchResult } from '../shared/match.model';
import { Standing } from '../shared/standing.model';
import { Coordinates } from '../shared/coordinates.model';
import { Team } from '../shared/team.model';
import { Goal } from '../shared/goal.model';
import { Card, CardType } from '../shared/card.model';
import { WindowRef } from '../shared/window-ref';
import { PlayerStatistic } from '../shared/player-statistic.model';
import { Clock } from '../shared/clock.model';
import { Score } from '../shared/score.model';
import { LivePlayerStatistic } from '../shared/live-player-statistic.model';
import { MatchType } from '../shared/configuration.model';
import { LastLineupMatch } from '../shared/last-lineup-match.model';
import { Referee } from '../shared/referee.model';
import { SetSizeToDirective } from '../shared/set-size-to.directive';
import {Trophie} from '../shared/trophie.model';

export enum FieldSide {
    Left,
    Right
}

export enum Popup {
    Score,
    MissingPlayers,
    NewPlayers,
    PenaltyStatistics,
    Matches,
    Standing,
    LeftTeam,
    RightTeam,
    Player,
    EditPlayer,
    PlayerDetails,
    Settings,
    Clock,
    ClockSettings,
    Bench,
    AddNewPlayer
}

@Component({
    selector: 'ct-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss'],
    host: {
        '(window:resize)': 'onResize($event)'
    }
})
export class FieldComponent implements OnInit, OnDestroy {
    FieldSide = FieldSide; // Make enums available in template
    Popup = Popup;
    MatchResult = MatchResult;
    CardType = CardType;

    Math = Math; // Make Math available in template

    @ViewChild('left') leftRef: ElementRef;
    @ViewChild('right') rightRef: ElementRef;
    @ViewChild('field') fieldRef: ElementRef;

    private ngUnsubscribe: Subject<void> = new Subject<void>();
    private leftRect: ClientRect;
    private playerRect: ClientRect = null;

    observer: MutationObserver;
    updateInterval = 60000;
    dragging = false;
    changeover = false;
    homeTeamMatchData: HomeTeamMatchData = new HomeTeamMatchData();
    awayTeamMatchData: AwayTeamMatchData = new AwayTeamMatchData();
    homeTeamLoaded = false;
    awayTeamLoaded = false;
    teamsLoaded = false;
    standings: Standing[] = [];
    referee: Referee;
    refereeLoaded = false;
	  popupScoreOpen = false;
    popupScoreFieldSide: FieldSide;
    popupMissingPlayersOpen = false;
    popupMissingPlayersFieldSide: FieldSide;
    popupNewPlayersOpen = false;
    popupNewPlayersFieldSide: FieldSide;
    popupPenaltyStatisticsOpen = false;
    popupPenaltyStatisticsFieldSide: FieldSide;
    popupPenaltyStatisticsOtherFieldSide: FieldSide;
    popupMatchesOpen = false;
    popupMatchesFieldSide: FieldSide;
    popupLeftTeamOpen = false;
    popupRightTeamOpen = false;
    popupPlayerOpen = false;
    popupPlayerFieldSide: FieldSide;
    popupPlayerX: number;
    popupPlayerY: number;
    popupPlayerId: number;
    popupPlayer: Player;
    popupPlayerAlignBottom = false;
    popupPlayerAlignRight = false;
    popupStandingOpen = false;
    popupStandingFieldSide: FieldSide;
    popupEditPlayerOpen = false;
    popupEditPlayer: Player;
    popupPlayerDetailsOpen = false;
    popupPlayerDetailsPlayer: Player;
    popupSettingsOpen = false;
    popupClockOpen = false;
    popupClockX = 0;
    popupClockY = 0;
    popupClockSettingsOpen = false;
    clock: Clock = new Clock();
    dragOverLeftX: number = null;
    dragOverLeftY: number = null;
    dragOverRightX: number = null;
    dragOverRightY: number = null;
    popupBenchOpen = false;
    popupBenchFieldSide: FieldSide;
    popupAddNewPlayerOpen =  false;
    popupAddNewPlayer: Player = new Player();
    popupTickerOpen = false;
    kickoffDate: Date = null;
    settings = {
        general: {
            tooltips: true
        },
        playerDetails: {
            transfers: true,
            injuries: true,
            trophies: true,
            livedata: true
        },
        field: {
            corners: true,
            tackles: true,
            possession: true,
            lastLineup: true,
            missingPlayers: true,
            newPlayers: true,
            table: false,
            ticker: false,
            penalties: false,
            prevMatch: false
        },
        player: {
            age: true,
            nationality: true,
            homeTeam: true,
            position: false,
            goals: true,
            yellowCards: true,
            birthday: true,
            height: true,
            newPlayer: true,
            captain: true,
            automaticGoalsAndCards: true
        },
        playerStatistic: {
            goalkeeper: {
                saves: true,
                passes: true,
                passAccuracy: true,
                assists: false
            },
            defender: {
                passAccuracy: true,
                fouls: false,
                interceptions: true,
                passes: true,
                shots: false,
                fouled: false,
                assists: false
            },
            midfielder: {
                passAccuracy: true,
                fouls: false,
                passes: true,
                shots: false,
                fouled: false,
                assists: true,
                offsides: false
            },
            attacker: {
                passAccuracy: false,
                fouls: false,
                passes: true,
                shots: true,
                fouled: false,
                assists: false,
                offsides: true
            }
        }
    };

    positions: string[] = [
        'Coach',
        'Goalkeeper',
        'Midfielder',
        'Defender',
        'Attacker'
    ];

    tickerEntries = [
        'KickOff delayed for 15 minutes due to traffic situation',
        'There will be a minute of silence before KickOff. Werner Faßbender ' +
        'will be honored. He was a former Vice-Präsident of Fortuna Düsseldorf ' +
        'and worked 25 years for the club. He died last week at the age of 84.'
    ];

    formations = {
        '3-4-3': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: true},
                {row: 2, column: 3, alignCenter: true},
                {row: 2, column: 2, alignCenter: true},
                {row: 3, column: 4, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 1, alignCenter: false},
                {row: 4, column: 4, alignCenter: true},
                {row: 5, column: 3, alignCenter: true},
                {row: 4, column: 2, alignCenter: true}
            ]
        },
        '3-5-2': {
            rows: 5,
            columns: 5,
            positions: [
                {row: 1, column: 3, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 2, column: 5, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 4, column: 5, alignCenter: false},
                {row: 3, column: 4, alignCenter: false},
                {row: 4, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 4, column: 1, alignCenter: false},
                {row: 5, column: 4, alignCenter: false},
                {row: 5, column: 2, alignCenter: false}
            ]
        },
        '4-3-3': {
            rows: 4,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 3, column: 4, alignCenter: true},
                {row: 3, column: 3, alignCenter: true},
                {row: 3, column: 2, alignCenter: true},
                {row: 4, column: 4, alignCenter: true},
                {row: 4, column: 3, alignCenter: true},
                {row: 4, column: 2, alignCenter: true}
            ]
        },
        '4-4-2': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 4, column: 4, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 4, column: 1, alignCenter: false},
                {row: 5, column: 3, alignCenter: false},
                {row: 5, column: 2, alignCenter: false}
            ]
        },
        '5-3-2': {
            rows: 4,
            columns: 5,
            positions: [
                {row: 1, column: 3, alignCenter: false},
                {row: 2, column: 5, alignCenter: false},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 3, column: 5, alignCenter: true},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: true},
                {row: 4, column: 4, alignCenter: true},
                {row: 4, column: 3, alignCenter: true}
            ]
        },
        '3-1-4-2': {
            rows: 6,
            columns: 5,
            positions: [
                {row: 1, column: 3, alignCenter: false},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 4, column: 3, alignCenter: false},
                {row: 3, column: 5, alignCenter: false},
                {row: 3, column: 1, alignCenter: false},
                {row: 5, column: 2, alignCenter: false},
                {row: 5, column: 4, alignCenter: false},
                {row: 6, column: 4, alignCenter: true},
                {row: 6, column: 3, alignCenter: true}
            ]
        },
        '3-4-1-2': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: true},
                {row: 2, column: 3, alignCenter: true},
                {row: 2, column: 2, alignCenter: true},
                {row: 3, column: 4, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 1, alignCenter: false},
                {row: 4, column: 3, alignCenter: true},
                {row: 5, column: 4, alignCenter: true},
                {row: 5, column: 2, alignCenter: true}
            ]
        },
        '3-4-2-1': {
            rows: 6,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: true},
                {row: 2, column: 3, alignCenter: true},
                {row: 2, column: 2, alignCenter: true},
                {row: 4, column: 4, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 4, column: 1, alignCenter: false},
                {row: 5, column: 4, alignCenter: true},
                {row: 5, column: 2, alignCenter: true},
                {row: 6, column: 3, alignCenter: true}
            ]
        },
        '3-5-1-1': {
            rows: 5,
            columns: 5,
            positions: [
                {row: 1, column: 3, alignCenter: false},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 3, column: 5, alignCenter: false},
                {row: 3, column: 4, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 3, column: 1, alignCenter: false},
                {row: 4, column: 3, alignCenter: false},
                {row: 5, column: 3, alignCenter: false}
            ]
        },
        '4-1-4-1': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 4, column: 4, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 4, column: 3, alignCenter: true},
                {row: 4, column: 1, alignCenter: false},
                {row: 5, column: 3, alignCenter: true}
            ]
        },
        '4-2-2-2': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 4, column: 4, alignCenter: false},
                {row: 4, column: 1, alignCenter: false},
                {row: 5, column: 3, alignCenter: false},
                {row: 5, column: 2, alignCenter: false}
            ]
        },
        '4-2-3-1': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 4, column: 4, alignCenter: false},
                {row: 4, column: 3, alignCenter: true},
                {row: 4, column: 1, alignCenter: false},
                {row: 5, column: 3, alignCenter: true}
            ]
        },
        '4-3-1-2': {
            rows: 6,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 4, column: 2, alignCenter: true},
                {row: 3, column: 3, alignCenter: true},
                {row: 4, column: 4, alignCenter: true},
                {row: 5, column: 3, alignCenter: true},
                {row: 6, column: 2, alignCenter: false},
                {row: 6, column: 3, alignCenter: false}
            ]
        },
        '4-3-2-1': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 4, column: 3, alignCenter: true},
                {row: 3, column: 3, alignCenter: true},
                {row: 3, column: 4, alignCenter: true},
                {row: 5, column: 3, alignCenter: false},
                {row: 3, column: 2, alignCenter: true},
                {row: 5, column: 2, alignCenter: false}
            ]
        },
        '4-4-1-1': {
            rows: 5,
            columns: 4,
            positions: [
                {row: 1, column: 3, alignCenter: true},
                {row: 2, column: 4, alignCenter: false},
                {row: 2, column: 3, alignCenter: false},
                {row: 2, column: 2, alignCenter: false},
                {row: 2, column: 1, alignCenter: false},
                {row: 3, column: 1, alignCenter: false},
                {row: 3, column: 2, alignCenter: false},
                {row: 3, column: 3, alignCenter: false},
                {row: 3, column: 4, alignCenter: false},
                {row: 4, column: 3, alignCenter: true},
                {row: 5, column: 3, alignCenter: true}
            ]
        }
    }

    constructor(
        public dataService: DataService,
        private toastsManager: ToastsManager,
        private windowRef: WindowRef,
        @Inject(DOCUMENT) private document: any,
        private changeDetectorRef: ChangeDetectorRef) {}

    ngOnInit() {
        this.toastsManager.info('Loading data...', 'Loading!');
        this.dataService.getTeams(this.dataService.configuration.league)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((teams: Team[]) => {
                this.teamsLoaded = true;
                for (const team of teams) {
                  if (team.teamId === this.dataService.configuration.homeTeam) {
                        this.homeTeamMatchData.team = team;
                    }

                    if (team.teamId === this.dataService.configuration.awayTeam) {
                        this.awayTeamMatchData.team = team;
                    }
                }
            });

        this.dataService.getPlayers(this.dataService.configuration.matchId, this.dataService.configuration.homeTeam)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((players: Player[]) => {
                for (const player of players) {
                    player.shortLastName = this.getPlayerShortLastName(player);
                    player.shortFirstName = this.getPlayerShortFirstName(player);
                }

                this.homeTeamLoaded = true;
                this.homeTeamMatchData.players = players;

                const w = this.document.body.clientWidth,
                    h = this.document.body.clientHeight,
                    clientWidth = this.Math.min(w / h, 1920 / 1080) * h,
                    clientHeight = this.Math.min(h / w, 1080 / 1920) * w;
                for (const player of players) {
                    if (player.x !== 0 && player.y !== 0) {
                        player.x = clientWidth / player.pitchWidth * player.x;
                        player.y = clientHeight / player.pitchHeight * player.y;

                        this.addPlayer(FieldSide.Left, player.playerId);
                    }
                }

                this.addCoach(players, FieldSide.Left);

                if (typeof players[0] === 'undefined') {
                    this.toastsManager.info('There is no data about the home team\'s players available.', 'Info!');
                } else {
                    this.toastsManager.success('The home team\'s player data has been loaded.', 'Success!');
                }
            });

        this.dataService.getPlayers(this.dataService.configuration.matchId, this.dataService.configuration.awayTeam)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((players: Player[]) => {
                for (const player of players) {
                    player.shortLastName = this.getPlayerShortLastName(player);
                    player.shortFirstName = this.getPlayerShortFirstName(player);
                }

                this.awayTeamLoaded = true;
                this.awayTeamMatchData.players = players;

                const w = this.document.body.clientWidth,
                    h = this.document.body.clientHeight,
                    clientWidth = this.Math.min(w / h, 1920 / 1080) * h,
                    clientHeight = this.Math.min(h / w, 1080 / 1920) * w;
                for (const player of players) {
                    if (player.x !== 0 && player.y !== 0) {
                        player.x = clientWidth / player.pitchWidth * player.x;
                        player.y = clientHeight / player.pitchHeight * player.y;

                        this.addPlayer(FieldSide.Right, player.playerId);
                    }
                }

                this.addCoach(players, FieldSide.Right);

                if (typeof players[0] === 'undefined') {
                    this.toastsManager.info('There is no data about the away team\'s players available..', 'Info!');
                } else {
                    this.toastsManager.success('The away team\'s player data has been loaded.', 'Success!');
                }
            });

        this.loadNewPlayers(FieldSide.Left);
        this.loadNewPlayers(FieldSide.Right);
        this.loadLastLineupMatch(FieldSide.Left);
        this.loadLastLineupMatch(FieldSide.Right);
        this.loadStandings(FieldSide.Left);
        this.loadStandings(FieldSide.Right);
        //this.startUpdateLiveStandings(FieldSide.Left);
        //this.startUpdateLiveStandings(FieldSide.Right);
        this.startUpdateLiveGoals();
        this.startUpdateLiveCards();
        this.loadReferee();

        this.updateLiveClock(
			this.dataService.configuration.matchId,
			this.updateInterval,
			(clock: Clock): void => {
				this.clock.minutes = clock.minutes;
				this.clock.seconds = clock.seconds;
				this.clock.status = clock.status;
				if (this.clock.status == 0 && this.clock.interval != null){
					this.stopClock();
				}else if (this.clock.status == 1 && this.clock.interval == null){
					this.startClock();
				}
			});

        this.updateLiveScore(
            this.dataService.configuration.matchId,
            this.updateInterval,
            (score: Score): void => {
                if (score.homeScore > this.homeTeamMatchData.goals) {
                    this.homeTeamMatchData.goals = score.homeScore;
                }

                if (score.awayScore > this.awayTeamMatchData.goals) {
                    this.awayTeamMatchData.goals = score.awayScore;
                }
            });

        this.updateLiveTeamStatistic(
            this.dataService.configuration.matchId,
            this.dataService.configuration.homeTeam,
            this.updateInterval,
            (teamStatistic: TeamStatistic): void => {
                if (teamStatistic === null) {
                    return;
                }

                this.homeTeamMatchData.teamStatistic = teamStatistic;
            });

        this.updateLiveTeamStatistic(
            this.dataService.configuration.matchId,
            this.dataService.configuration.awayTeam,
            this.updateInterval,
            (teamStatistic: TeamStatistic): void => {
                if (teamStatistic === null) {
                    return;
                }

                this.awayTeamMatchData.teamStatistic = teamStatistic;
            });

        this.observer = new MutationObserver((mutations, observer) => {
            const element = mutations[0].target.firstChild.parentElement;
            if (element.style.left !== '' && element.style.top !== '' && !element.classList.contains('dragged')) {
                element.classList.add('dragged');
            }

            observer.disconnect();
        });
    }

    ngAfterViewInit() {
        this.leftRect = this.leftRef.nativeElement.getBoundingClientRect();
    }

    isInitialized() {
        return this.homeTeamLoaded
            && this.awayTeamLoaded
            && this.teamsLoaded
            && this.homeTeamMatchData.transfersLoaded
            && this.awayTeamMatchData.transfersLoaded
            && this.refereeLoaded
            && this.dataService.isInitialized();
    }

    addPlayer(fieldSide: FieldSide, playerId: number): boolean {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        if (this.isPlayerOnField(fieldSide, playerId)) {
            this.toastsManager.info('This player is already on the field.', 'Info!');
            return false;
        }

        let newPlayer: Player;
        for (const player of teamMatchData.players) {
            if (player.playerId === playerId) {
                newPlayer = player;
            }
        }

        if (typeof newPlayer === 'undefined') {
            this.toastsManager.error('The selected player does not play for this team.', 'Error!');
            return false;
        }

        newPlayer.shortFirstName = this.getPlayerShortFirstName(newPlayer);
        newPlayer.shortLastName = this.getPlayerShortLastName(newPlayer);

        if (!newPlayer.playerStatisticLoaded) {
            this.loadPlayerStatistic(newPlayer);
        }

        teamMatchData.customLineup = true;
        this.updateLivePlayerStatistic(this.dataService.configuration.matchId, newPlayer, this.updateInterval);
        teamMatchData.activePlayers.push(newPlayer);
        this.updatePlayerRect();
        return true;
    }

    removePlayer(playerId: number) {
        for (let i = 0; i < this.homeTeamMatchData.activePlayers.length; i++) {
            if (this.homeTeamMatchData.activePlayers[i].playerId === playerId) {
                // Reset position
                this.homeTeamMatchData.activePlayers[i].x = this.homeTeamMatchData.activePlayers[i].y = 0;

                this.homeTeamMatchData.activePlayers[i].livePlayerStatisticSubscription.unsubscribe();
                this.homeTeamMatchData.activePlayers.splice(i, 1);

                return;
            }
        }

        for (let i = 0; i < this.awayTeamMatchData.activePlayers.length; i++) {
            if (this.awayTeamMatchData.activePlayers[i].playerId === playerId) {
                // Reset position
                this.awayTeamMatchData.activePlayers[i].x = this.awayTeamMatchData.activePlayers[i].y = 0;

                this.awayTeamMatchData.activePlayers[i].livePlayerStatisticSubscription.unsubscribe();
                this.awayTeamMatchData.activePlayers.splice(i, 1);

                return;
            }
        }
    }

    clearField(fieldSide: FieldSide) {
        for (const player of this.getTeamMatchData(fieldSide).activePlayers) {
            player.livePlayerStatisticSubscription.unsubscribe();
        }

        this.getTeamMatchData(fieldSide).activePlayers = [];
    }

    isBirthday(player: Player) {
        return +player.birthDate.format('D') === +moment().format('D') && +player.birthDate.format('M') === +moment().format('M');
    }

    getTeamColor(team: number) {
        if (team === this.dataService.configuration.homeTeam) {
            return this.homeTeamMatchData.color;
        } else if (team === this.dataService.configuration.awayTeam) {
            return this.awayTeamMatchData.color;
        }

        return 'inherit';
    }

    getPlayerById(playerId: number) {
        for (const player of this.homeTeamMatchData.players) {
            if (player.playerId === playerId) {
                return player;
            }
        }

        for (const player of this.awayTeamMatchData.players) {
            if (player.playerId === playerId) {
                return player;
            }
        }

        return new Player();
    }

    getMatchResult(fieldSide: FieldSide, match: Match): MatchResult {
        if (match.homeTeamScore === match.awayTeamScore) {
            return MatchResult.Draw;
        }

        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        if ((team === match.homeTeamId && match.homeTeamScore > match.awayTeamScore)
            || (team === match.awayTeamId && match.awayTeamScore > match.homeTeamScore)) {
            return MatchResult.Win;
        } else {
            return MatchResult.Loss;
        }
    }

    onResize(event: any) {
        const resizedLeftRect = this.leftRef.nativeElement.getBoundingClientRect();
        const resizedPlayerRect = this.getPlayerRect();
        for (const player of this.homeTeamMatchData.activePlayers) {
            player.x = (player.x / this.leftRect.width) * resizedLeftRect.width;
            player.y = (player.y / this.leftRect.height) * resizedLeftRect.height;
        }

        for (const player of this.awayTeamMatchData.activePlayers) {
            player.x = (player.x / this.leftRect.width) * resizedLeftRect.width;
            player.y = (player.y / this.leftRect.height) * resizedLeftRect.height;
        }

        this.leftRect = resizedLeftRect;
        this.playerRect = resizedPlayerRect;
    }

    onChangeover() {
        this.changeover = !this.changeover;
    }

    onRemovePlayer(player: number) {
        this.popupPlayerOpen = false;
        this.removePlayer(player);
    }

    onDragStart(event: any) {
        this.dragging = true;
        this.observer.observe(event, {
            attributes: true,
            attributeFilter: ['style'],
            childList: false,
            subtree: false,
            characterData: false
        });
    }

    onDragEnd(event: any) {
        this.dragging = false;
        const playerId = +event.getAttribute('player');
        if (playerId === 0) {
            return;
        }
        let found = false;
        this.leftRect = this.leftRef.nativeElement.getBoundingClientRect();
        for (const player of this.homeTeamMatchData.activePlayers) {
            if (player.playerId === playerId) {
                if (!this.changeover) {
                    player.y = parseInt(event.style.top);
                    player.x = parseInt(event.style.left);
                } else {
                    player.y = this.leftRect.height - event.getBoundingClientRect().height - parseInt(event.style.top);
                    player.x = this.leftRect.width - event.getBoundingClientRect().width - parseInt(event.style.left);
                }

                found = true;
                break;
            }
        }

        if (found === false) {
            for (const player of this.awayTeamMatchData.activePlayers) {
                if (player.playerId === playerId) {
                    if (this.changeover) {
                        player.y = parseInt(event.style.top);
                        player.x = parseInt(event.style.left);
                    } else {
                        player.y = this.leftRect.height - event.getBoundingClientRect().height - parseInt(event.style.top);
                        player.x = this.leftRect.width - event.getBoundingClientRect().width - parseInt(event.style.left);
                    }

                    break;
                }
            }
        }
    }

    onPlayerItemDragStart(event: any) {
        this.dragging = true;
    }

    onPlayerItemDragEnd(event: any) {
        this.dragging = false;
        let dragOverX = null;
        let dragOverY = null;
        if (event.fieldSide === FieldSide.Left) {
            dragOverX = this.dragOverLeftX;
            dragOverY = this.dragOverLeftY;
        } else {
            dragOverX = this.dragOverRightX;
            dragOverY = this.dragOverRightY;
        }

        if (dragOverX !== null && dragOverY !== null) {
            this.leftRect = this.leftRef.nativeElement.getBoundingClientRect();
            if (this.addPlayer(event.fieldSide, event.player.playerId)) {
                if (event.fieldSide === FieldSide.Left) {
                    event.player.y = dragOverY;
                    event.player.x = dragOverX;
                } else {
                    event.player.y = this.leftRect.height - dragOverY - this.playerRect.height;
                    event.player.x = this.leftRect.width - dragOverX - this.playerRect.width;
                }
            }
        }

        this.dragOverLeftX = null;
        this.dragOverLeftY = null;
        this.dragOverRightX = null;
        this.dragOverRightY = null;
    }

    onDragOver(event: any, fieldSide: FieldSide) {
        if (fieldSide === FieldSide.Left) {
            if (event.target.id === 'left') {
                this.dragOverLeftX = event.layerX > 0 ? event.layerX : 0;
                this.dragOverLeftY = event.layerY > 0 ? event.layerY : 0;
            }
        } else {
            if (event.target.id === 'right') {
                this.dragOverRightX = event.layerX > 0 ? event.layerX : 0;
                this.dragOverRightY = event.layerY > 0 ? event.layerY : 0;
            }
        }
    }

    onPlayerNameChange(player: Player) {
        if (!player.name || player.name.length < 1) {
            return;
        }

        player.shortLastName = this.getPlayerShortLastName(player);
        player.shortFirstName = this.getPlayerShortFirstName(player);
    }

    openPopup(fieldSide: FieldSide, popup: Popup, event: any) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        switch (popup) {
            case Popup.Score: {
                this.popupScoreFieldSide = fieldSide;
                this.popupScoreOpen = !this.popupScoreOpen;
                break;
            }
            case Popup.MissingPlayers: {
                if (!teamMatchData.missingPlayersLoaded) {
                    this.loadMissingPlayers(fieldSide);
                }

                this.popupMissingPlayersFieldSide = fieldSide;
                this.popupMissingPlayersOpen = !this.popupMissingPlayersOpen;
                break;
            }
            case Popup.NewPlayers: {
                this.popupNewPlayersFieldSide = fieldSide;
                this.popupNewPlayersOpen = !this.popupNewPlayersOpen;
                break;
            }
            case Popup.PenaltyStatistics: {
                this.popupPenaltyStatisticsFieldSide = fieldSide;
                this.popupPenaltyStatisticsOtherFieldSide =
                    fieldSide === FieldSide.Left ? FieldSide.Right : FieldSide.Left;

                this.homeTeamMatchData.goalkeeperPenaltyStatistics = [];
                this.homeTeamMatchData.penaltyStatistics = [];
                this.awayTeamMatchData.goalkeeperPenaltyStatistics = [];
                this.awayTeamMatchData.penaltyStatistics = [];

                for (const player of this.homeTeamMatchData.players.concat(this.awayTeamMatchData.players)) {
                    this.loadPlayerPenaltyStatistics(player);
                }

                this.popupPenaltyStatisticsOpen = !this.popupPenaltyStatisticsOpen;
                break;
            }
            case Popup.Matches: {
                if (!teamMatchData.nextMatchesLoaded) {
                    this.loadNextMatches(fieldSide);
                }

                if (!teamMatchData.prevMatchesLoaded) {
                    this.loadPrevMatches(fieldSide);
                }

                this.popupMatchesFieldSide = fieldSide;
                this.popupMatchesOpen = !this.popupMatchesOpen;
                break;
            }
            case Popup.Standing: {
                this.popupStandingFieldSide = fieldSide;
                this.popupStandingOpen = !this.popupStandingOpen;
                break;
            }
            case Popup.LeftTeam: {
                if (this.popupBenchOpen && this.popupBenchFieldSide === FieldSide.Left) {
                    this.popupBenchOpen = false;
                }

                this.popupLeftTeamOpen = !this.popupLeftTeamOpen;
                this.changeDetectorRef.detectChanges(); // Wait for draggable events to get added to the DOM
                this.fixDragEvent();
                break;
            }
            case Popup.RightTeam: {
                if (this.popupBenchOpen && this.popupBenchFieldSide === FieldSide.Right) {
                    this.popupBenchOpen = false;
                }

                this.popupRightTeamOpen = !this.popupRightTeamOpen;
                this.changeDetectorRef.detectChanges(); // Wait for draggable events to get added to the DOM
                this.fixDragEvent();
                break;
            }
            case Popup.Player: {
                this.popupPlayerAlignBottom = false;
                this.popupPlayerAlignRight = false;
                this.popupPlayerX = event.mouseEvent.clientX;
                this.popupPlayerY = event.mouseEvent.clientY;
                this.popupPlayer = event.player;
                this.popupPlayerId = event.player.playerId;
                this.popupPlayerFieldSide = fieldSide;
                this.popupPlayerOpen = !this.popupPlayerOpen;
                this.changeDetectorRef.detectChanges(); // Wait for popup to get rendered
                const popupEl = this.document.querySelector('.popup-player');
                const rect = popupEl.getBoundingClientRect();
                const viewportWidth = Math.max(this.document.documentElement.clientWidth, this.windowRef.nativeWindow.innerWidth || 0);
                const viewportHeight = Math.max(this.document.documentElement.clientHeight, this.windowRef.nativeWindow.innerHeight || 0);
                if (rect.top + rect.height > viewportHeight) {
                    this.popupPlayerAlignBottom = true;
                }

                if (rect.left + rect.width > viewportWidth) {
                    this.popupPlayerAlignRight = true;
                }

                return false;
            }
            case Popup.EditPlayer: {
                this.popupEditPlayer = event;
                this.popupEditPlayerOpen = !this.popupEditPlayerOpen;
                break;
            }
            case Popup.PlayerDetails: {
                if (!event.transfersLoaded) {
                    this.loadTransfers(event);
                }

                if (!event.injuriesLoaded) {
                    this.loadInjuries(event);
                }

                this.loadTrophies(event);

                this.popupPlayerDetailsPlayer = event;
                this.popupPlayerDetailsOpen = !this.popupPlayerDetailsOpen;
                break;
            }
            case Popup.Settings: {
                this.popupSettingsOpen = !this.popupSettingsOpen;
                break;
            }
            case Popup.Clock: {
                this.popupClockY = event.clientY;
                this.popupClockX = event.clientX;
                this.popupClockOpen = !this.popupClockOpen;
                break;
            }
            case Popup.ClockSettings: {
                this.popupClockSettingsOpen = !this.popupClockSettingsOpen;
                break;
            }
            case Popup.Bench: {
                if (fieldSide === FieldSide.Left) {
                    this.popupLeftTeamOpen = false;
                } else {
                    this.popupRightTeamOpen = false;
                }

                this.popupBenchFieldSide = fieldSide;
                this.popupBenchOpen = !this.popupBenchOpen;
                this.changeDetectorRef.detectChanges(); // Wait for draggable events to get added to the DOM
                this.fixDragEvent();
                break;
            }
            case Popup.AddNewPlayer: {
                if (fieldSide === FieldSide.Left) {
                    this.popupRightTeamOpen = false;
                } else {
                    this.popupLeftTeamOpen = false;
                }
                this.popupAddNewPlayerOpen = true;
                this.popupAddNewPlayer = new Player();
                this.popupAddNewPlayer.playerId = 0;
                this.popupAddNewPlayer.id = 0;
                this.popupAddNewPlayer.teamId = this.getTeamMatchData(fieldSide).team.teamId;
                break;
            }
        }
    }

    addGoal() {
        if (!this.popupScoreOpen) {
            return;
        }

        this.getTeamMatchData(this.popupScoreFieldSide).goals++;
    }

    removeGoal() {
        const teamMatchData = this.getTeamMatchData(this.popupScoreFieldSide);
        if (!this.popupScoreOpen || teamMatchData.goals <= 0) {
            return;
        }

        teamMatchData.goals--;
    }

    startClock() {
        if (this.clock.interval !== null) {
            this.toastsManager.info('The clock is already running.', 'Info!');
            return;
        }

        this.clock.interval = setInterval(this.updateClock.bind(this), 1000);
    }

    stopClock() {
        if (this.clock.interval !== null) {
	        //clearInterval(this.clock.interval.data.handleId);
	        clearInterval(this.clock.interval);
            this.clock.interval = null;
        }
    }

    resetClock() {
        this.stopClock();
        this.clock = new Clock();
    }

    setClock() {
        this.popupClockOpen = false;
        this.stopClock();
        this.openPopup(null, Popup.ClockSettings, null);
    }

    updateClock() {
        this.clock.seconds++;
        if (this.clock.seconds >= 60) {
            this.clock.minutes++;
            this.clock.seconds = 0;
        }
    }

    pad(num: number, length?: number) {
        length = length || 2;
        return (new Array(length).join('0') + num).slice(length * -1);
    }

    updatePlayerBirthDate(player: Player) {
        player.birthDate = moment(`${player.birthYear}${this.pad(player.birthMonth)}${this.pad(player.birthDay)}`, 'YYYYMMDD');
        player.age = +player.birthDate.fromNow();
    }

    toggleCaptain(player: Player) {
        player.isCaptain = !player.isCaptain;
        this.popupPlayerOpen = false;
    }

    givePlayerGoal(player: Player) {
        this.popupPlayerOpen = false;

        this.addPlayerGoal(player, this.clock.minutes + 1);

        if (this.dataService.configuration.matchType === MatchType.Manual) {
            if (player.teamId === this.dataService.configuration.homeTeam) {
                this.homeTeamMatchData.goals++;
            } else {
                this.awayTeamMatchData.goals++;
            }
        }
    }

    getPlayerShortFirstName(player: Player) {
        const parts = player.name.split(' ');
        if (new RegExp(/^\S\.\s+(.*)$/g).test(player.name)) {
            const firstNameParts = player.firstName.split(' ');
            if (firstNameParts[0].length <= 4) {
                return [firstNameParts[0], firstNameParts[1]].join(' ');
            }

            return firstNameParts[0];
        } else if (new RegExp(/^\S+$/g).test(player.name)) {
            return null;
        }

        return parts[0];
    }

    getPlayerShortLastName(player: Player) {
        return player.name.includes(' ') ? player.name.substr(player.name.indexOf(' ')) : player.name;
    }

    removePlayerGoal(player: Player) {
        this.popupPlayerOpen = false;
        if (player.goals.length <= 0) {
            return;
        }

        player.goals.pop();
        player.seasonGoals--;
        if (this.dataService.configuration.isNational) {
            player.nationalGoals--;
        }

        if (this.dataService.configuration.matchType === MatchType.Manual) {
            if (player.teamId === this.dataService.configuration.homeTeam) {
                this.homeTeamMatchData.goals--;
            } else {
                this.awayTeamMatchData.goals--;
            }
        }
    }

    givePlayerYellowCard(player: Player) {
        this.popupPlayerOpen = false;
        if (player.cards.length >= 2 || (player.cards.length === 1 && player.cards[0].type === CardType.Red)) {
            return;
        }

        this.addPlayerCard(player, this.clock.minutes + 1, CardType.Yellow);
    }

    givePlayerRedCard(player: Player) {
        this.popupPlayerOpen = false;
        if (player.cards.length >= 2 || (player.cards.length === 1 && player.cards[0].type === CardType.Red)) {
            return;
        }

        this.addPlayerCard(player, this.clock.minutes + 1, CardType.Red);
    }

    removePlayerCard(player: Player) {
        this.popupPlayerOpen = false;
        if (player.cards.length <= 0) {
            return;
        }

        const card = player.cards.pop();
        if (card.type === CardType.Yellow) {
            player.playerStatistic.yellowCards--;
        } else {
            player.playerStatistic.redCards--;
        }
    }

    editPlayer(player: Player) {
        this.popupPlayerOpen = false;
        this.openPopup(null, Popup.EditPlayer, player);
    }

    showPlayerDetails(player: Player) {
        this.popupPlayerOpen = false;
        this.openPopup(null, Popup.PlayerDetails, player);
    }

    loadInjuries(player: Player) {
        this.dataService.getInjuries(player.playerId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((injuries: Injury[]) => {
                player.injuries = injuries;
                player.injuriesLoaded = true;
            });
    }

    loadTrophies(player: Player) {
        this.dataService.getTrophies(player.playerId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((trophies: Trophie[]) => {
                player.trophies = trophies;
            });
    }

    loadTransfers(player: Player) {
        this.dataService.getTransfers(player.playerId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((transfers: Transfer[]) => {
                player.transfers = transfers;
                player.transfersLoaded = true;
            });
    }

    loadPlayerStatistic(player: Player) {
        this.dataService.getPlayerStatistic(this.dataService.configuration.matchId, player.playerId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((playerStatistic: PlayerStatistic) => {
                if (playerStatistic !== null) {
                    player.playerStatistic = playerStatistic;
                    player.playerStatisticLoaded = true;
                }
            });
    }

    loadLiveLineup(fieldSide: FieldSide) {
        const toastText = 'There is no data about this team\'s upcoming lineup available. Please check again 30 minutes before the start of the game.';

        //if (this.kickoffDate === null || moment().isBefore(moment(this.kickoffDate).subtract(45, 'minutes'))) {
        //    this.toastsManager.info(toastText, 'Info!', {toastLife: 10000});
        //    return;
        //}

        this.clearField(fieldSide);
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getLiveLineup(this.dataService.configuration.matchId, team)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((lineup: Lineup) => {
                if (typeof lineup.positions[0] === 'undefined') {
                    this.toastsManager.info(toastText, 'Info!', {toastLife: 10000});
                    return;
                }

                teamMatchData.customLineup = true;
                this.placeLineup(fieldSide, lineup);
            }, () => {
            }, () => {
                this.addCoach(this.getTeamMatchData(fieldSide).players, fieldSide);
            });
    }

    loadReferee() {
        this.dataService.getReferee(this.dataService.configuration.matchId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((referee: Referee) => {
                this.refereeLoaded = true;
                this.referee = referee;
            });
    }

    getPlayerRect() {
        const playerEl = this.document.getElementsByClassName('player')[0];
        if (typeof playerEl === 'undefined') {
            return null;
        }

        return playerEl.getBoundingClientRect();
    }

    updatePlayerRect(force: boolean = false) {
        const playerCards = this.document.getElementsByClassName('player');
        if (playerCards.length > 0 && (force || this.playerRect === null)) {
            this.changeDetectorRef.detectChanges(); // Make sure the player is added to the DOM before measuring it
            this.playerRect = playerCards[0].getBoundingClientRect();
        }
    }

    placeLineup(fieldSide: FieldSide, lineup: Lineup) {
        // Reset substitutes
        const teamMatchData = this.getTeamMatchData(fieldSide);
        for (const player of teamMatchData.players) {
            player.bench = false;
        }

        const playersToCenter: Player[] = [];

        // Apply lineup
        lineupLoop: for (const position of lineup.positions) {
            if (position.substitution) {
                for (const player of teamMatchData.players) {
                    if (position.player === player.playerId) {
                        player.bench = true;
                        continue lineupLoop;
                    }
                }
            }


            if (position.position !== 0 && !this.isPlayerOnField(fieldSide, position.player)) {
                for (const player of teamMatchData.players) {
                    if (position.player === player.playerId) {
                        teamMatchData.activePlayers.push(player);
                        const coordinates = this.getPositionCoordinates(position.position, lineup.formation);
                        player.x = coordinates.x;
                        player.y = coordinates.y;
                        if (coordinates.alignCenter) {
                            playersToCenter.push(player);
                        }
                        if (!player.playerStatisticLoaded) {
                            this.loadPlayerStatistic(player);
                        }

                        this.updateLivePlayerStatistic(this.dataService.configuration.matchId, player, this.updateInterval);
                        this.updatePlayerRect();
                    }
                }
            }
        }

        // Use setTimeout to move the centering of players on the "stack" of events
        // so that they get centered AFTER their size has been calculated.
        setTimeout(() => {
            for (const player of playersToCenter) {
                player.y -= player.clientHeight / 2;
            }
        }, 0);
    }

    /*calculatePlayerFontSize(player: Player) {
        this.changeDetectorRef.detectChanges(); // Make sure the player is added to the DOM before measuring its width
        const playerEl = this.document.querySelector('[player="' + player.playerId + '"]');
        let lastnameEl = playerEl.querySelector('.header .lastname');
        const lastnameTextEl = lastnameEl.querySelector('span');
        player.lastnameLinebreak = false;
        if(!this.setFullWidthFontSize(lastnameEl, lastnameTextEl, 10)) {
            player.lastnameLinebreak = true;
        }

        let firstnameEl = playerEl.querySelector('.header .firstname');
        const firstnameTextEl = firstnameEl.querySelector('span');
        this.setFullWidthFontSize(firstnameEl, firstnameTextEl);
    }

    setFullWidthFontSize(container, text, min = 1) {
        let n = 15;
        container.style.fontSize = n + 'px';
        while(this.getElementWidth(text) > this.getElementWidth(container)) {
            if(n < min) {
                return false;
            }

            container.style.fontSize = (--n) + 'px';
        }

        return true;
    }*/

    getElementWidth(element) {
        return element.getBoundingClientRect().width;
    }

    teamHasInjuredPlayers(fieldSide: FieldSide): boolean {
        const teamMatchData = this.getTeamMatchData(fieldSide);

        if (teamMatchData.missingPlayers.length === 0) {
            return false;
        }

        for (const missingPlayer of teamMatchData.missingPlayers) {
            if (missingPlayer.type === 'Injured') {
                return true;
            }
        }

        return false;
    }

    teamHasSuspendedPlayers(fieldSide: FieldSide): boolean {
        const teamMatchData = this.getTeamMatchData(fieldSide);

        if (teamMatchData.missingPlayers.length === 0) {
            return false;
        }

        for (const missingPlayer of teamMatchData.missingPlayers) {
            if (missingPlayer.type === 'Suspended' || missingPlayer.type === 'Unknown') {
                return true;
            }
        }

        return false;
    }

    isPlayerOnField(fieldSide: FieldSide, player: number): boolean {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        for (const activePlayer of teamMatchData.activePlayers) {
            if (activePlayer.playerId === player) {
                return true;
            }
        }

        return false;
    }

    isNewPlayer(player: Player) {
        const teamMatchData = player.teamId === this.dataService.configuration.homeTeam
            ? this.homeTeamMatchData
            : this.awayTeamMatchData;

        for (const transfer of teamMatchData.transfers) {
            if (transfer.playerId === player.playerId) {
                return true;
            }
        }

        return false;
    }

    getPositionCoordinates(position: number, formation: string): Coordinates {
        if (!(formation in this.formations)) {
            formation = Object.keys(this.formations)[0]; // Fall back to first formation if given formation does not exist
        }

        this.leftRect = this.leftRef.nativeElement.getBoundingClientRect();
        const padding = this.leftRect.width * .05;
        const width = this.leftRect.width;
        const height = this.leftRect.height - padding * 2;
        const coordinates = new Coordinates();
        const formationData = this.formations[formation];
        const positionData = formationData.positions[position - 1];
        coordinates.x = width / formationData.rows * (positionData.row - 1);
        coordinates.y = padding + height / formationData.columns * (positionData.column - 1);
        coordinates.alignCenter = positionData.alignCenter;
        return coordinates;
    }

    loadLastLineup(fieldSide: FieldSide) {
        this.clearField(fieldSide);
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getLastLineup(this.dataService.configuration.matchId, team)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((lineup: Lineup) => {
                if (typeof lineup.positions[0] === 'undefined') {
                    this.toastsManager.info('There is no data about this team\'s latest lineup available.', 'Info!');
                    return;
                }

                this.placeLineup(fieldSide, lineup);
            }, () => {
            }, () => {
                this.addCoach(this.getTeamMatchData(fieldSide).players, fieldSide);
            });
    }

    loadMissingPlayers(fieldSide: FieldSide) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getMissingPlayers(team, moment())
            .takeUntil(this.ngUnsubscribe)
            .subscribe((missingPlayers: MissingPlayer[]) => {
                teamMatchData.missingPlayers = missingPlayers;
                teamMatchData.missingPlayersLoaded = true;
            });
    }

    loadNewPlayers(fieldSide: FieldSide) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getNewPlayers(team, +moment().format('YYYY'))
            .takeUntil(this.ngUnsubscribe)
            .subscribe((transfers: Transfer[]) => {
                teamMatchData.transfers = transfers;
                teamMatchData.transfersLoaded = true;
            });
    }

    loadPlayerPenaltyStatistics(player: Player) {
        const teamMatchData = (player.teamId === this.dataService.configuration.homeTeam ? this.homeTeamMatchData : this.awayTeamMatchData);
        this.dataService.getPlayerPenaltyStatistic(this.dataService.configuration.league, player.playerId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((penaltyStatistic: PenaltyStatistic) => {
                if (penaltyStatistic !== null) {
                    if (player.position === 'Goalkeeper') {
                        teamMatchData.goalkeeperPenaltyStatistics.push(penaltyStatistic);
                    } else {
                        teamMatchData.penaltyStatistics.push(penaltyStatistic);
                    }
                    this.loadPlayerLeaguePenalties(player);
                }
            });
    }

    loadPlayerLeaguePenalties(player: Player) {
        this.dataService.getPlayerLeaguePenalties(this.dataService.configuration.league, player.playerId)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((penalties: Penalty[]) => {
                player.penalties = penalties;
            });
    }

    loadLastLineupMatch(fieldSide: FieldSide) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getLastLineupMatch(this.dataService.configuration.matchId, team)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((lastLineupMatch: LastLineupMatch) => {
                if (lastLineupMatch !== null) {
                    teamMatchData.lastLineupMatch = lastLineupMatch;
                    teamMatchData.lastLineupMatchLoaded = true;
                }
            });
    }

    loadPrevMatches(fieldSide: FieldSide) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getTeamMatches(team, DataDirection.Last, 5)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((matches: Match[]) => {
                teamMatchData.prevMatches = matches;
                teamMatchData.prevMatchesLoaded = true;
            });
    }

    loadNextMatches(fieldSide: FieldSide) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getTeamMatches(team, DataDirection.Next, 5)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((matches: Match[]) => {
                teamMatchData.nextMatches = matches;
                teamMatchData.nextMatchesLoaded = true;
            });
    }

    loadStandings(fieldSide: FieldSide) {
        const teamMatchData = this.getTeamMatchData(fieldSide);
        const team = teamMatchData.matchSide === MatchSide.Home
            ? this.dataService.configuration.homeTeam
            : this.dataService.configuration.awayTeam;

        this.dataService.getLeagueStanding(this.dataService.configuration.league, team)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((standings: Standing[]) => {
                this.standings = standings;
            });
    }

    savePlayerPositions() {
        // Show start toast
        this.toastsManager.info('Saving player positions...', 'Saving');
        // Get players from both sides
        let players: Player[] = [];

        // Add players to array for saving them, setting their position to 0 on both x and y to if they are currently
        // not placed on the field
        players = players.concat(this.getTeamMatchData(FieldSide.Left).players.map((player: Player) => {
            if (!this.isPlayerOnField(FieldSide.Left, player.playerId)) {
                player.x = player.y = 0;
            }
            return player;
        }, this));
        players = players.concat(this.getTeamMatchData(FieldSide.Right).players.map((player: Player) => {
            if (!this.isPlayerOnField(FieldSide.Right, player.playerId)) {
                player.x = player.y = 0;
            }
            return player;
        }, this));

        // Save players
        this.dataService.savePlayerPositions(players, this.fieldRef.nativeElement.clientWidth, this.fieldRef.nativeElement.clientHeight).subscribe(() => {
            this.toastsManager.info('Saved player positions', 'Saving');
        }, () => {
            this.toastsManager.error('Player positions could not be saved', 'Saving');
        });
    }

    toggleFullscreen() {
        if (screenfull.enabled) {
            screenfull.toggle();
            // this.resetPlayerDragEvent();
        } else {
            this.toastsManager.warning('Failed to enter fullscreen mode.', 'Warning!');
        }
    }

    // resetPlayerDragEvent() {
    //     let players = this.document.getElementsByClassName('player');
    //     for(let player of players) {
    //         player.classList.remove('dragged');
    //         player.style.top = 'auto';
    //         player.style.left = 'auto';
    //         player.style.bottom = 'auto';
    //         player.style.right = 'auto';
    //     }
    // }

    getTeamMatchData(fieldSide: FieldSide) {
        if ((fieldSide === FieldSide.Left && !this.changeover) || (fieldSide === FieldSide.Right && this.changeover)) {
          return this.homeTeamMatchData;
        }
        return this.awayTeamMatchData;
    }

    updateLivePlayerStatistic(match: number, player: Player, interval: number) {
        player.livePlayerStatisticSubscription = Observable
            .timer(0, interval)
            .flatMap(() => {
                return this.dataService.getLivePlayerStatistic(match, player.playerId);
            })
            .takeUntil(this.ngUnsubscribe)
            .subscribe((livePlayerStatistic: LivePlayerStatistic) => {
                if (livePlayerStatistic !== null) {
                    player.livePlayerStatistic = livePlayerStatistic;
                }
            });
    }

    updateLiveScore(match: number, interval: number, success: (score: Score) => void) {
        return Observable
            .timer(0, interval)
            .flatMap(() => {
                return this.dataService.getLiveScore(match);
            })
            .takeUntil(this.ngUnsubscribe)
            .subscribe(success,
              (error) => {
              console.log('error', error)
            });
    }

	updateLiveClock(match: number, interval: number, success: (clock: Clock) => void) {
        return Observable
            .timer(0, interval)
            .flatMap(() => {
                return this.dataService.getClock(match);
            })
            .takeUntil(this.ngUnsubscribe)
            .subscribe(success);
	}

    startUpdateLiveStandings(fieldSide: FieldSide) {
        return Observable
            .timer(0, this.updateInterval)
            .subscribe(() => {
                this.loadStandings(fieldSide);
            });
    }

    startUpdateLiveGoals(): void {
        Observable
            .timer(0, this.updateInterval)
            .subscribe(() => {
                if (!this.settings.player.automaticGoalsAndCards) {
                    return;
                }

                this.dataService.getLiveGoals(this.dataService.configuration.matchId).subscribe(data => {
                    const json = data.json(),
                        players = this.homeTeamMatchData.players.concat(this.awayTeamMatchData.players);

                    for (const player of players) {
                        // Remove all goals and count down season goals
                        player.seasonGoals -= player.goals.length;
                        if (this.dataService.configuration.isNational) {
                            player.nationalGoals -= player.goals.length;
                        }
                        player.goals = [];
                        for (const goal of json) {
                            if (+goal.playerID === player.playerId) {
                                this.addPlayerGoal(player, +goal.minute);
                            }
                        }
                    }
                });
            });
    }

    startUpdateLiveCards(): void {
        Observable
            .timer(0, this.updateInterval)
            .subscribe(() => {
                if (!this.settings.player.automaticGoalsAndCards) {
                    return;
                }

                this.dataService.getLiveCards(this.dataService.configuration.matchId).subscribe(data => {
                    const json = data.json(),
                        players = this.homeTeamMatchData.players.concat(this.awayTeamMatchData.players);

                    for (const player of players) {
                        // Reset cards
                        for (const card of player.cards) {
                            if (card.type === CardType.Yellow) {
                                player.playerStatistic.yellowCards--;
                            } else if (card.type === CardType.Red) {
                                player.playerStatistic.redCards--;
                            }
                        }
                        player.cards = [];

                        for (const card of json) {
                            if (+card.playerID === player.playerId) {
                                this.addPlayerCard(player, +card.minute,
                                    card.cardType === 'Y' ? CardType.Yellow : CardType.Red);
                            }
                        }
                    }
                });
            });
    }

    addPlayerGoal(player: Player, minute: number): void {
        const goal = new Goal();
        goal.minute = minute;
        player.goals.push(goal);
        player.seasonGoals++;
        if (this.dataService.configuration.isNational) {
            player.nationalGoals++;
        }
    }

    addPlayerCard(player: Player, minute: number, type: CardType): void {
        const card = new Card();
        card.type = type;
        card.minute = minute;

        player.cards.push(card);

        if (type === CardType.Yellow) {
            player.playerStatistic.yellowCards++;
        } else if (type === CardType.Red) {
            player.playerStatistic.redCards++;
        }
    }

  updateLiveTeamStatistic(match: number, team: number, interval: number, success: (teamStatistic: TeamStatistic) => void) {
    const fetchData = () => {
      return Observable.create(observer => {
        this.dataService.getLiveTeamStatistic(match, team)
          .subscribe(
            teamStatistic => {
              observer.next(teamStatistic);
              observer.complete();
            },
            error => {
              console.log('error', error);
              observer.next(null); // Continue with a null value after error
              observer.complete();
            }
          );
      });
    };

    Observable.timer(0, interval)
      .mergeMap(() => {
        console.log('statistics are called');
        return fetchData();
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe(success);

    // Recurse after the interval to repeat the process
    setTimeout(() => {
      if (!this.ngUnsubscribe.closed) {
        fetchData().subscribe();
      }
    }, interval);
  }

    hasLastLineupMatch(fieldSide: FieldSide): boolean {
        return this.getTeamMatchData(fieldSide).lastLineupMatchLoaded;
    }

    getLastLineupMatch(fieldSide: FieldSide): LastLineupMatch {
        if (!this.hasLastLineupMatch(fieldSide)) {
            return null;
        }

        return this.getTeamMatchData(fieldSide).lastLineupMatch;
    }

    getLastLineupMatchResult(fieldSide: FieldSide, lastLineupMatch: LastLineupMatch): MatchResult {
        if (!this.hasLastLineupMatch(fieldSide) || lastLineupMatch.homeTeamScore === lastLineupMatch.awayTeamScore) {
            return MatchResult.Draw;
        }

        const teamMatchData = this.getTeamMatchData(fieldSide);
        if ((teamMatchData.team.name === lastLineupMatch.homeTeamName && lastLineupMatch.homeTeamScore > lastLineupMatch.awayTeamScore)
            || (teamMatchData.team.name === lastLineupMatch.awayTeamName && lastLineupMatch.awayTeamScore > lastLineupMatch.homeTeamScore)) {
            return MatchResult.Win;
        } else {
            return MatchResult.Loss;
        }
    }

    printLastLineupMatch(fieldSide: FieldSide): string {
        if (!this.hasLastLineupMatch(fieldSide)) {
            return null;
        }

        const teamMatchData = this.getTeamMatchData(fieldSide);
        const lastLineupMatch = teamMatchData.lastLineupMatch;
        return lastLineupMatch.homeTeamName + ' ' + lastLineupMatch.homeTeamScore + ':' + lastLineupMatch.awayTeamScore + ' '
            + lastLineupMatch.awayTeamName;
    }

    onSaveKeyfacts(player: Player): void {
        this.dataService.saveKeyfacts(player).subscribe(() => {
            this.toastsManager.info('Player key facts have been saved', 'Saving');
        }, () => {
            this.toastsManager.error('Player key facts could not be saved', 'Saving');
        });
    }

    fixDragEvent() {
        // Firefox requires data to be transfered
        const elements = this.document.querySelectorAll('[draggable=true]');
        for (const element of elements) {
            element.addEventListener('dragstart', function(event) {
                event.dataTransfer.setData('Data', this.id);
            });
        }
    }

    updateFontColor(teamMatchData) {
        const rgb = this.hexToRgb(teamMatchData.color);
        if (rgb === null) {
            return;
        }

        const contrast = this.getColorContrast(rgb.r, rgb.g, rgb.b);
        if (contrast > 190) {
            teamMatchData.fontColor = 'black';
            teamMatchData.overlayOpacity = 1;
            teamMatchData.invertColorPickerIcon = true;
        } else {
            teamMatchData.fontColor = 'white';
            teamMatchData.overlayOpacity = .75;
            teamMatchData.invertColorPickerIcon = false;
        }
    }

    onAddPlayer(player: Player) {
        player.id = 0;
        player.name = `${player.firstName.substr(0, 1)}. ${player.lastName}`;
        this.dataService.addPlayer(player).subscribe((response) => {
            const players = (player.teamId === this.homeTeamMatchData.team.teamId) ?
                this.homeTeamMatchData.players : this.awayTeamMatchData.players,
                json = response.json(),
                savedPlayer: Player = new Player();

            savedPlayer.id = +json.id;
            savedPlayer.number = +json.number;
            savedPlayer.country = json.country;
            if (savedPlayer.country === 'Bosnia and Herzegovina') {
                savedPlayer.country = 'Bosnia a. H.';
            } else if (savedPlayer.country === 'Republic of Ireland') {
                savedPlayer.country = 'Rep. Ireland';
            }

            savedPlayer.description = json.description;
            savedPlayer.position = json.position;
            savedPlayer.birthDate = moment(json.birthDate, 'DD/MM/YYYY');
            savedPlayer.birthDay = +savedPlayer.birthDate.format('D');
            savedPlayer.birthMonth = +savedPlayer.birthDate.format('M');
            savedPlayer.birthYear = +savedPlayer.birthDate.format('YYYY');
            savedPlayer.firstName = json.firstName;
            savedPlayer.lastName = json.lastName;
            savedPlayer.nationality = json.nationality;
            savedPlayer.nationalMatches = +json.matchesNT;
            savedPlayer.nationalGoals = +json.goalsNT;
            savedPlayer.birthCountry = json.birthCountry;
            savedPlayer.weight = json.weight;
            savedPlayer.teamId = +json.teamID;
            savedPlayer.birthPlace = json.birthPlace;
            savedPlayer.seasonGoals = +json.goals;
            savedPlayer.playerId = +json.playerID;
            savedPlayer.name = json.playerName;
            savedPlayer.age = +json.age;
            savedPlayer.height = json.height;
            savedPlayer.keyfacts = json.keyfacts;
            savedPlayer.x = +json.posX;
            savedPlayer.y = +json.posY;
            savedPlayer.pitchWidth = +json.pitchWidth;
            savedPlayer.pitchHeight = +json.pitchHeight;

            // Calculate birthday
            savedPlayer.age = +moment().diff(moment(savedPlayer.birthDate), 'years');

            players.push(savedPlayer);
            this.toastsManager.info('Player succesfully saved', 'Saving');
        }, () => {
            this.toastsManager.error('Player could not be saved', 'Saving');
        }, () => {
            this.popupAddNewPlayerOpen = false;
        });
    }

    isCoach(player: Player): boolean {
        return player.position === 'Coach';
    }

    addCoach(players: Player[], fieldSide: FieldSide): void {

        // Check for already placed coach
        for (const player of this.getTeamMatchData(fieldSide).activePlayers) {
            if (player.position === 'Coach') {
                return;
            }
        }

        // Search for the first coach and place him on the field
        for (const player of players) {
            if (player.position === 'Coach' && !this.isPlayerOnField(fieldSide, player.playerId)) {
                player.x = player.x || 65;
                player.y = player.y || 65;
                this.addPlayer(fieldSide, player.playerId)
                break;
            }
        }
    }

	isMissingPlayerInjured(missingPlayer): boolean {
		return true;
	}

    getColorContrast(red: number, green: number, blue: number) {
        return Math.round((red * 299 + green * 587 + blue * 114) / 1000);
    }

    hexToRgb(hex) {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b) => {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/field/field.component.ts